import EventContent from './event-content';
import { Metadata } from 'next';

export async function generateMetadata({ params }: { params: { id: string } }): Promise<Metadata> {
  return {
    title: 'Event - Momira',
    description: 'View and share photos from this event on Momira.',
    openGraph: {
      title: 'Event - Momira',
      description: 'View and share photos from this event on Momira.',
      type: 'website',
      images: [
        {
          url: '/og-image.png',
          width: 1200,
          height: 630,
          alt: 'Momira - Event Photos',
        },
      ],
    },
    twitter: {
      card: 'summary_large_image',
      title: 'Event - Momira',
      description: 'View and share photos from this event on Momira.',
      images: ['/og-image.png'],
    },
  };
}

export async function generateStaticParams() {
  return [{ id: 'placeholder' }];
}

export default function EventPage() {
  return <EventContent />;
}

